import React from "react";
import exterior_002 from "./images/exterior_002.jpg";
import { FaWhatsapp } from "react-icons/fa";

function Booking() {
  try {
    const [formData, setFormData] = React.useState({
      name: "",
      phone: "",
      checkIn: "",
      checkOut: "",
      guests: "",
      rooms: "",
      message: "",
    });

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    };

    const handleWhatsAppBooking = () => {
      const message = `Hi! I'd like to book Angelo's Farm.
      
Name: ${formData.name}
Phone: ${formData.phone}
Check-in: ${formData.checkIn}
Check-out: ${formData.checkOut}
Number of Guests: ${formData.guests}
Number of Rooms: ${formData.rooms}
Message: ${formData.message}`;

      const whatsappUrl = `https://wa.me/919256828782?text=${encodeURIComponent(
        message
      )}`;
      window.open(whatsappUrl, "_blank");
    };

    return (
      <section
        className="section-padding bg-white px-4 sm:px-6 lg:px-8"
        data-name="booking"
        data-file="components/Booking.js"
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Form */}
            <div>
              <div className="mb-6"></div>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-6">
                Book Your Stay
              </h2>
              <p className="text-xl text-stone-600 mb-8">
                Ready to experience luxury at Angelo's Farm? Fill out the form
                below and we'll get back to you shortly.
              </p>

              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="relative">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      id="booking-name"
                      className={`peer w-full px-4 py-3 border border-stone-300 rounded-lg focus:border-[#B86A4B] focus:shadow-none placeholder-transparent ${
                        formData.name ? "not-empty" : ""
                      }`}
                      placeholder="Full Name"
                      required
                    />
                    <label
                      htmlFor="booking-name"
                      className={`absolute left-3 px-1 text-stone-500 bg-white transition-all duration-200 pointer-events-none
          ${
            formData.name
              ? "-top-3 left-2 text-xs text-[#B86A4B]"
              : "top-3 left-4 text-base text-stone-500"
          }
          peer-focus:-top-3 peer-focus:left-2 peer-focus:text-xs peer-focus:text-[#B86A4B]`}
                    >
                      Full Name
                    </label>
                  </div>
                  <div className="relative">
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      id="booking-phone"
                      className={`peer w-full px-4 py-3 border border-stone-300 rounded-lg focus:border-[#B86A4B] focus:shadow-none placeholder-transparent ${
                        formData.phone ? "not-empty" : ""
                      }`}
                      placeholder="Phone Number"
                      required
                    />
                    <label
                      htmlFor="booking-phone"
                      className={`absolute left-3 px-1 text-stone-500 bg-white transition-all duration-200 pointer-events-none
          ${
            formData.phone
              ? "-top-3 left-2 text-xs text-[#B86A4B]"
              : "top-3 left-4 text-base text-stone-500"
          }
          peer-focus:-top-3 peer-focus:left-2 peer-focus:text-xs peer-focus:text-[#B86A4B]`}
                    >
                      Phone Number
                    </label>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="relative">
                    <input
                      type="date"
                      name="checkIn"
                      value={formData.checkIn}
                      onChange={handleInputChange}
                      id="booking-checkin"
                      className={`peer w-full px-4 py-3 border border-stone-300 rounded-lg focus:border-[#B86A4B] focus:shadow-none placeholder-transparent ${
                        formData.checkIn ? "not-empty" : ""
                      }`}
                      placeholder="Check-in Date"
                      required
                    />
                    <label
                      htmlFor="booking-checkin"
                      className={`absolute left-3 px-1 text-stone-500 bg-white transition-all duration-200 pointer-events-none
          ${
            formData.checkIn
              ? "-top-3 left-2 text-xs text-[#B86A4B]"
              : "top-3 left-4 text-base text-stone-500"
          }
          peer-focus:-top-3 peer-focus:left-2 peer-focus:text-xs peer-focus:text-[#B86A4B]`}
                    >
                      Check-in Date
                    </label>
                  </div>
                  <div className="relative">
                    <input
                      type="date"
                      name="checkOut"
                      value={formData.checkOut}
                      onChange={handleInputChange}
                      id="booking-checkout"
                      className={`peer w-full px-4 py-3 border border-stone-300 rounded-lg focus:border-[#B86A4B] focus:shadow-none placeholder-transparent ${
                        formData.checkOut ? "not-empty" : ""
                      }`}
                      placeholder="Check-out Date"
                      required
                    />
                    <label
                      htmlFor="booking-checkout"
                      className={`absolute left-3 px-1 text-stone-500 bg-white transition-all duration-200 pointer-events-none
          ${
            formData.checkOut
              ? "-top-3 left-2 text-xs text-[#B86A4B]"
              : "top-3 left-4 text-base text-stone-500"
          }
          peer-focus:-top-3 peer-focus:left-2 peer-focus:text-xs peer-focus:text-[#B86A4B]`}
                    >
                      Check-out Date
                    </label>
                  </div>
                </div>

                <div className="relative">
                  <select
                    name="guests"
                    value={formData.guests}
                    onChange={handleInputChange}
                    id="booking-guests"
                    className={`peer w-full px-4 py-3 border border-stone-300 rounded-lg focus:border-[#B86A4B] focus:shadow-none placeholder-transparent ${
                      formData.guests ? "not-empty" : ""
                    }`}
                    required
                  >
                    <option value="" disabled hidden></option>
                    {[...Array(20)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1} Guest{i > 0 ? "s" : ""}
                      </option>
                    ))}
                  </select>
                  <label
                    htmlFor="booking-guests"
                    className={`absolute left-3 px-1 text-stone-500 bg-white transition-all duration-200 pointer-events-none
          ${
            formData.guests
              ? "-top-3 left-2 text-xs text-[#B86A4B]"
              : "top-3 left-4 text-base text-stone-500"
          }
          peer-focus:-top-3 peer-focus:left-2 peer-focus:text-xs peer-focus:text-[#B86A4B]`}
                  >
                    Number of Guests
                  </label>
                </div>
                <div className="relative">
                  <select
                    name="rooms"
                    value={formData.rooms}
                    onChange={handleInputChange}
                    id="booking-rooms"
                    className={`peer w-full px-4 py-3 border border-stone-300 rounded-lg focus:border-[#B86A4B] focus:shadow-none placeholder-transparent ${
                      formData.rooms ? "not-empty" : ""
                    }`}
                    required
                  >
                    <option value="" disabled hidden></option>
                    {[...Array(20)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1} Room{i > 0 ? "s" : ""}
                      </option>
                    ))}
                  </select>
                  <label
                    htmlFor="booking-rooms"
                    className={`absolute left-3 px-1 text-stone-500 bg-white transition-all duration-200 pointer-events-none
          ${
            formData.rooms
              ? "-top-3 left-2 text-xs text-[#B86A4B]"
              : "top-3 left-4 text-base text-stone-500"
          }
          peer-focus:-top-3 peer-focus:left-2 peer-focus:text-xs peer-focus:text-[#B86A4B]`}
                  >
                    Number of Rooms
                  </label>
                </div>

                <div className="relative">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    id="booking-message"
                    rows="4"
                    className={`peer w-full px-4 py-3 border border-stone-300 rounded-lg focus:border-[#B86A4B] focus:shadow-none placeholder-transparent ${
                      formData.message ? "not-empty" : ""
                    }`}
                    placeholder="Special Requests"
                    required
                  ></textarea>
                  <label
                    htmlFor="booking-message"
                    className={`absolute left-3 px-1 text-stone-500 bg-white transition-all duration-200 pointer-events-none
          ${
            formData.message
              ? "-top-3 left-2 text-xs text-[#B86A4B]"
              : "top-3 left-4 text-base text-stone-500"
          }
          peer-focus:-top-3 peer-focus:left-2 peer-focus:text-xs peer-focus:text-[#B86A4B]`}
                  >
                    Special Requests
                  </label>
                </div>

                <button
                  onClick={handleWhatsAppBooking}
                  className="w-full text-lg py-4 px-8 rounded-xl font-semibold transition-all duration-300 shadow-lg bg-[#B86A4B] text-white hover:bg-[#a0522d] flex items-center justify-center"
                >
                  <FaWhatsapp size={30} style={{ marginRight: "6px" }} />
                  Send Booking Request via WhatsApp
                </button>
                <div className="mb-6"></div>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="relative">
              <img
                src={exterior_002}
                alt="Angelo's Farm Booking"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl"></div>
              <div className="absolute bottom-6 left-6 text-white">
                <h3 className="text-2xl font-serif font-bold mb-2">
                  Your Perfect Getaway Awaits
                </h3>
                <p className="text-lg">
                  Experience luxury and comfort at Angelo's Farm
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  } catch (error) {
    console.error("Booking component error:", error);
    return null;
  }
}

export default Booking;
